import { render, staticRenderFns } from "./ADetalleInscrito.vue?vue&type=template&id=e5b37378"
import script from "./ADetalleInscrito.vue?vue&type=script&lang=js"
export * from "./ADetalleInscrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports